import React, { useState, useEffect } from 'react';

import { APP_URL, SCREEN_SIZE } from 'types';
import {
  SideNavLink,
  SideNavMenu,
  SideNavMenuItem
} from 'carbon-components-react';
import {
  WatsonHealthMagnify16,
  ReportData16,
  Enterprise16,
  UserMultiple16,
  Api16,
  Bullhorn16
} from '@carbon/icons-react';
import { useHistory } from 'react-router-dom';

export const LeftNavDBYDAdmin: React.FC<any> = ({ screenSize, isAADBYD }) => {
  const history = useHistory();
  const [pathname, setPathname] = useState<string>(history?.location?.pathname);

  useEffect(() => {
    history && setPathname(history.location?.pathname);
  }, [history]);

  return (
    <>
      <div className="divider" />
      {/* member */}
      {screenSize &&
        [SCREEN_SIZE.MAX, SCREEN_SIZE.XL, SCREEN_SIZE.LG].includes(
          screenSize
        ) && (
          <SideNavMenu
            renderIcon={Enterprise16}
            title="Members"
            isActive={pathname.includes(APP_URL.MEMBERS)}
            defaultExpanded={pathname.includes(APP_URL.MEMBERS)}
          >
            <SideNavMenuItem
              isActive={pathname === APP_URL.MEMBERS}
              onClick={() => history.push(`${APP_URL.MEMBERS}`)}
            >
              Manage members
            </SideNavMenuItem>
            <SideNavMenuItem
              isActive={pathname.includes(APP_URL.AOI_VIEWER)}
              onClick={() => history.push(`${APP_URL.AOI_VIEWER}`)}
            >
              AOI viewer
            </SideNavMenuItem>
          </SideNavMenu>
        )}
      {/* Reporting */}
      <SideNavLink
        aria-current={pathname === APP_URL.REPORTS ? 'page' : undefined}
        renderIcon={ReportData16}
        onClick={() => history.push(`${APP_URL.REPORTS}`)}
      >
        Reporting
      </SideNavLink>
      {/* All Enquiry History */}
      <SideNavLink
        aria-current={
          pathname === APP_URL.ALL_ENQUIRIY_HISTORY ? 'page' : undefined
        }
        renderIcon={WatsonHealthMagnify16}
        onClick={() => history.push(`${APP_URL.ALL_ENQUIRIY_HISTORY}`)}
      >
        Enquiry history
      </SideNavLink>
      <div className="divider" />
      {screenSize &&
        [SCREEN_SIZE.MAX, SCREEN_SIZE.XL, SCREEN_SIZE.LG].includes(
          screenSize
        ) && (
          <>
            {isAADBYD && (
              <SideNavLink
                renderIcon={Bullhorn16}
                aria-current={
                  pathname === APP_URL.MANAGE_ANNOUNCEMENTS ? 'page' : undefined
                }
                onClick={() => history.push(APP_URL.MANAGE_ANNOUNCEMENTS)}
              >
                Manage announcements
              </SideNavLink>
            )}
            <SideNavLink
              renderIcon={UserMultiple16}
              aria-current={
                pathname === APP_URL.USERS_ADMIN ? 'page' : undefined
              }
              onClick={() => history.push(APP_URL.USERS_ADMIN)}
            >
              Manage users
            </SideNavLink>
            <SideNavLink
              renderIcon={Api16}
              aria-current={
                pathname === APP_URL.PREMIUM_FEATURES ? 'page' : undefined
              }
              onClick={() => history.push(APP_URL.PREMIUM_FEATURES)}
            >
              Premium features
            </SideNavLink>

            <div className="divider" />
          </>
        )}
      {/* Integrations */}
    </>
  );
};

export default LeftNavDBYDAdmin;
